import { IsDefined, IsInt, IsNotEmpty, IsObject, IsString, ValidateIf, isDefined, IsOptional } from 'class-validator';

import { TaxonomyValues } from '../taxonomy-values';

export class TaxonomyReferenceItemUpdateRequest {
    @ValidateIf((o: TaxonomyReferenceItemUpdateRequest) => isDefined(o.uuid) || !isDefined(o.referenceUuid))
    @IsDefined({ message: '"uuid" is required when "referenceUuid" is not set' })
    @IsString()
    @IsNotEmpty()
    public uuid?: string;

    @ValidateIf((o: TaxonomyReferenceItemUpdateRequest) => isDefined(o.referenceUuid) || !isDefined(o.uuid))
    @IsDefined({ message: '"referenceUuid" is required when "uuid" is not set' })
    @IsString()
    @IsNotEmpty()
    public referenceUuid?: string;

    @IsOptional()
    @IsString()
    @IsNotEmpty()
    public parentUuid?: string | null;

    @IsOptional()
    @IsInt()
    public order?: number;

    @IsOptional()
    @IsObject()
    public values?: TaxonomyValues;

    constructor(data?: Partial<TaxonomyReferenceItemUpdateRequest>) {
        this.uuid = data?.uuid;
        this.referenceUuid = data?.referenceUuid;
        this.parentUuid = data?.parentUuid;
        this.order = data?.order;
        this.values = data?.values;
    }
}
